const POSTBACK_URL = 'https://ad.propellerads.com/conversion.php'
const AID = '3496819'
const PID = ''
const TID = '100631'
const DEFAULT_PAYOUT = 35

export const CLICK_ID_KEY = 'clickid'
export const SOURCE_KEY = 'source'

export function persistTrafficParams() {
  try {
    const url = new URL(window.location.href)
    const clickid = url.searchParams.get('clickid')
    const source = url.searchParams.get('source')

    if (clickid) {
      localStorage.setItem(CLICK_ID_KEY, clickid)
      document.cookie =
        CLICK_ID_KEY +
        `=${encodeURIComponent(clickid)}; path=/; max-age=${60 * 60 * 24 * 30}; samesite=lax`
    }

    if (source) {
      localStorage.setItem(SOURCE_KEY, source)
    }
  } catch {}
}

export function getClickId(): string | null {
  const ls = localStorage.getItem(CLICK_ID_KEY)
  if (ls) return ls

  const cookies = document.cookie.split(';').map((s) => s.trim())
  const found = cookies.find((c) => c.startsWith(CLICK_ID_KEY + '='))
  return found ? decodeURIComponent(found.split('=')[1]) : ''
}

export async function sendPropellerPostback(opts: { clickId?: string }) {
  const cid = opts.clickId ?? getClickId()

  const url =
    `${POSTBACK_URL}?aid=${AID}` +
    `&pid=${PID}` +
    `&tid=${TID}` +
    `&visitor_id=${cid}` +
    `&payout=${DEFAULT_PAYOUT}`
  try {
    await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
    return true
  } catch (e) {
    return false
  }
}
